import { render, staticRenderFns } from "./giftToMePopup.vue?vue&type=template&id=a8e4eb08&scoped=true"
import script from "./giftToMePopup.vue?vue&type=script&lang=js"
export * from "./giftToMePopup.vue?vue&type=script&lang=js"
import style0 from "./giftToMePopup.vue?vue&type=style&index=0&id=a8e4eb08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e4eb08",
  null
  
)

export default component.exports